export const userType = {
  SILVER: "Silver",
  FREE: "Free",
  GOLD_USER: "Gold",
  PLATINUM_USER: "Platinum",
};
